<template>
  <block-item-card
    ref="descriptiveStatistics"
    :base-currency-symbol="riskBaseCurrencyDisplayName"

    :title="$t('ALM.Section.InvestmentsPortfolio.DescriptiveStatistics.Title')"
    :title-value-color-red="false"
  >
    <v-card-text
      class="pb-2 "
    >
      <item-chart-legend
        :key="`alm-investments-portfolio-descriptive-statistics-legend-size`"
        :background-color="themeColorRGBA('synthesis-ui-grey-06', 1)"
        :description="$t('ALM.Section.InvestmentsPortfolio.DescriptiveStatistics.Size.Description')"
        :base-currency-symbol="riskBaseCurrencyDisplayName"
        :title="$t('ALM.Section.InvestmentsPortfolio.DescriptiveStatistics.Size.Title')"
        :title-value="sizeValue"
        :title-value-class="'font-weight-medium d-flex align-center'"
      />

      <item-chart-legend
        :key="`alm-investments-portfolio-descriptive-statistics-legend-investments`"
        :background-color="themeColorRGBA('synthesis-ui-grey-06', 1)"
        :description="$t('ALM.Section.InvestmentsPortfolio.DescriptiveStatistics.Investments.Description')"
        :title="$t('ALM.Section.InvestmentsPortfolio.DescriptiveStatistics.Investments.Title')"
        :title-value="investmentsValue"
        :title-value-class="'font-weight-medium d-flex align-center'"
      />

      <item-chart-legend
        :key="`alm-investments-portfolio-descriptive-statistics-legend-maturity`"
        :background-color="themeColorRGBA('synthesis-ui-grey-06', 1)"
        :description="$t('ALM.Section.InvestmentsPortfolio.DescriptiveStatistics.Maturity.Description')"
        :title="$t('ALM.Section.InvestmentsPortfolio.DescriptiveStatistics.Maturity.Title')"
        :title-value="maturityValue"
        :title-value-class="'font-weight-medium d-flex align-center'"
      />
      <item-chart-legend
        :key="`alm-investments-portfolio-descriptive-statistics-legend-yield`"
        :background-color="themeColorRGBA('synthesis-ui-grey-06', 1)"
        :description="$t('ALM.Section.InvestmentsPortfolio.DescriptiveStatistics.Yield.Description')"
        :title="$t('ALM.Section.InvestmentsPortfolio.DescriptiveStatistics.Yield.Title')"
        :title-value="yieldValue"
        :title-value-class="'font-weight-medium d-flex align-center'"
      />
      <item-chart-legend
        :key="`alm-investments-portfolio-descriptive-statistics-legend-market-value`"
        :background-color="themeColorRGBA('synthesis-ui-grey-06', 1)"
        :description="$t('ALM.Section.InvestmentsPortfolio.DescriptiveStatistics.MarketValue.Description')"
        :base-currency-symbol="riskBaseCurrencyDisplayName"
        :title="$t('ALM.Section.InvestmentsPortfolio.DescriptiveStatistics.MarketValue.Title')"
        :title-value="marketValueValue"
        :title-value-class="'font-weight-medium d-flex align-center'"
      />
      <item-chart-legend
        :key="`alm-investments-portfolio-descriptive-statistics-legend-duration`"
        :background-color="themeColorRGBA('synthesis-ui-grey-06', 1)"
        :description="$t('ALM.Section.InvestmentsPortfolio.DescriptiveStatistics.Duration.Description')"
        :title="$t('ALM.Section.InvestmentsPortfolio.DescriptiveStatistics.Duration.Title')"
        :title-value="durationValue"
        :title-value-class="'font-weight-medium d-flex align-center'"
      />
    </v-card-text>
  </block-item-card>
</template>
<script>
import BlockItemCard      from '@/theme/default/components/common/BlockItemCard'
import ItemChartLegend    from '@/theme/default/components/common/ItemChartLegend'
import baseEChartColors   from '@/theme/default/components/charts/echarts/mixins/common/baseEChartColors'
import i18nRouteMeta                     from '@/mixins/i18n/i18nRouteMeta'
import riskBaseCurrency   from '@/theme/default/views/risks/mixins/riskBaseCurrency'
import { toNumberFormatNotationShort, toDecimalSignificant } from '@/lib/utils/helper'
import riskAnalysisId from '@/theme/default/views/risks/mixins/riskAnalysisId'

export default {
  name      : 'ALMInvestmentsDescriptiveStatistics',
  components: { BlockItemCard, ItemChartLegend },
  directives: {},
  mixins    : [i18nRouteMeta, riskBaseCurrency, baseEChartColors, riskAnalysisId],
  props     : {},
  dataStore : {
    appToolbarExtended: 'App.Config.AppToolbarExtended',

    Investments: 'ALM.Investments.Data',

    riskBaseCurrencyData: 'Risks.BaseCurrency.Data'
  },
  enums: {},
  data () {
    return {
      breakpoint    : (this.appToolbarExtended && this.$vuetify.breakpoint.smAndDown ? 12 : 6),
      minBlockHeight: 364
    }
  },
  computed: {
    descriptiveStatistics () {
      return this.Investments.DescriptiveStatistics || null
    },
    sizeValue () {
      return this.descriptiveStatistics.size ? toNumberFormatNotationShort(this.descriptiveStatistics.size) : ''
    },
    investmentsValue () {
      return this.descriptiveStatistics.investments ? this.descriptiveStatistics.investments.toLocaleString('en-US') : ''
    },
    maturityValue () {
      return this.descriptiveStatistics.maturity ? toDecimalSignificant(this.descriptiveStatistics.maturity) + ' ' + this.descriptiveStatistics.maturityUnit : ''
    },
    yieldValue () {
      return this.descriptiveStatistics.yield ? toDecimalSignificant(this.descriptiveStatistics.yield) + '%' : ''
    },
    marketValueValue () {
      return this.descriptiveStatistics.marketValue ? toNumberFormatNotationShort(this.descriptiveStatistics.marketValue) : ''
    },
    durationValue () {
      return this.descriptiveStatistics.duration ? toDecimalSignificant(this.descriptiveStatistics.duration) + ' ' + this.descriptiveStatistics.durationUnit : ''
    }
  },
  watch: {
    appToolbarExtended (val) {
      this.breakpoint = val && this.$vuetify.breakpoint.smAndDown ? 12 : 6
    },

    '$vuetify.breakpoint.smAndDown': {
      handler (val) {
        this.breakpoint = val && this.appToolbarExtended ? 12 : 6
      }
    }

  },
  created () {
  },
  beforeMount () {},
  mounted () {
  },
  beforeUpdate () {},
  updated () {},
  destroyed () {},
  methods: {

  }
}
  </script>

  <style scoped>

  </style>
